<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{ billName }}</label>
            <em class="weui-form-preview__value">{{ form.main.vc_code }}</em>
          </div>
        </div>

        <div
          class="weui-form-preview__bd"
          v-if="billName == '预收冲应收' || '冲预收款'"
        >
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="vc_custname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_custname || "客户"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_custname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount1">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount1 || "预收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount2">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount2 || "应收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount2
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_currency">
              <label class="weui-form-preview__label">{{
                customLabel.vc_currency || "币种"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.vc_currency }}
                <span v-if="form.main.vc_rate && form.main.vc_rate != 1"
                  >/ {{ form.main.vc_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="vc_date">
              <label class="weui-form-preview__label">{{
                customLabel.vc_date || "日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.vc_date
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="form.main.vc_text1" slot="vc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="form.main.vc_text2" slot="vc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="form.main.vc_text3" slot="vc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="form.main.vc_text4" slot="vc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="form.main.vc_text5" slot="vc_text5" hidden="true" />
          </custom-layout>
        </div>

        <div class="weui-form-preview__bd" v-if="billName == '应收冲应付'">
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="vc_custname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_custname || "客户"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_custname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_vendname || "供应商"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_vendname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount1">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount1 || "应收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount2">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount2 || "应付余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount2
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_currency">
              <label class="weui-form-preview__label">{{
                customLabel.vc_currency || "币种"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.vc_currency }}
                <span v-if="form.main.vc_rate && form.main.vc_rate != 1"
                  >/ {{ form.main.vc_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="vc_date">
              <label class="weui-form-preview__label">{{
                customLabel.vc_date || "日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.vc_date
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="form.main.vc_text1" slot="vc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="form.main.vc_text2" slot="vc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="form.main.vc_text3" slot="vc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="form.main.vc_text4" slot="vc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="form.main.vc_text5" slot="vc_text5" hidden="true" />
          </custom-layout>
        </div>

        <div class="weui-form-preview__bd" v-if="billName == '应收转应收'">
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="vc_custname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_custname || "转出客户"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_custname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount1">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount1 || "应收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_turncustname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_turncustname || "转入客户"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_turncustname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount2">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount2 || "应收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount2
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_currency">
              <label class="weui-form-preview__label">{{
                customLabel.vc_currency || "币种"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.vc_currency }}
                <span v-if="form.main.vc_rate && form.main.vc_rate != 1"
                  >/ {{ form.main.vc_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="vc_date">
              <label class="weui-form-preview__label">{{
                customLabel.vc_date || "日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.vc_date
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="form.main.vc_text1" slot="vc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="form.main.vc_text2" slot="vc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="form.main.vc_text3" slot="vc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="form.main.vc_text4" slot="vc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="form.main.vc_text5" slot="vc_text5" hidden="true" />
          </custom-layout>
        </div>

        <div class="weui-form-preview__bd" v-if="billName == '冲应收款'">
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="vc_custname">
              <label class="weui-form-preview__label">{{
                customLabel.vc_custname || "客户"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.vc_custname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="vc_leftamount1">
              <label class="weui-form-preview__label">{{
                customLabel.vc_leftamount1 || "应收余额(元)"
              }}</label>
              <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
                form.main.vc_leftamount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vc_currency">
              <label class="weui-form-preview__label">{{
                customLabel.vc_currency || "币种"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.vc_currency }}
                <span v-if="form.main.vc_rate && form.main.vc_rate != 1"
                  >/ {{ form.main.vc_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="vc_date">
              <label class="weui-form-preview__label">{{
                customLabel.vc_date || "日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.vc_date
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="form.main.vc_text1" slot="vc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="form.main.vc_text2" slot="vc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="form.main.vc_text3" slot="vc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="form.main.vc_text4" slot="vc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="form.main.vc_text5" slot="vc_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">
          {{
            billName == "预收冲应收" || billName == "冲预收款"
              ? "预收单据"
              : "应收单据"
          }}
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.vd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="vd_slcode">
              <label class="weui-form-preview__label">{{
                customLabel.vd_slcode || "来源单号"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.vd_slkind }} {{ item.vd_slcode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="vd_emname">
              <label class="weui-form-preview__label">{{
                customLabel.vd_emname || "业务员"
              }}</label>
              <span class="weui-form-preview__value">{{ item.vd_emname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.vd_amount || "单据金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.vd_amount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sl_yamount">
              <label class="weui-form-preview__label">{{
                customLabel.sl_yamount || "已核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sl_yamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vd_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.vd_nowbalance || "本次核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.vd_nowbalance,'#,##0.00')
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vd_text1 || '自定义字段1'"
            v-model="item.vd_text1" slot="vd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vd_text2 || '自定义字段2'"
            v-model="item.vd_text2" slot="vd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vd_text3 || '自定义字段3'"
            v-model="item.vd_text3" slot="vd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vd_text4 || '自定义字段4'"
            v-model="item.vd_text4" slot="vd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vd_text5 || '自定义字段5'"
            v-model="item.vd_text5" slot="vd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="
          billName != '应收转应收' &&
          billName != '冲应收款' &&
          billName != '冲预收款'
        "
      >
        <div class="weui-panel__hd">
          {{ billName == "预收冲应收" ? "应收单据" : "应付单据" }}
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.vcd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="vcd_slcode">
              <label class="weui-form-preview__label">{{
                customLabel.vcd_slcode || "来源单号"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.vcd_slkind }} {{ item.vcd_slcode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="vcd_emname">
              <label class="weui-form-preview__label">{{
                customLabel.vcd_emname || "业务员"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vcd_emname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vcd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.vcd_amount || "单据金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.vcd_amount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sl_yamount">
              <label class="weui-form-preview__label">{{
                customLabel.sl_yamount || "已核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sl_yamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vcd_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.vcd_nowbalance || "本次核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.vcd_nowbalance,'#,##0.00')
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.vcd_text1 || '自定义字段1'"
            v-model="item.vcd_text1" slot="vcd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vcd_text2 || '自定义字段2'"
            v-model="item.vcd_text2" slot="vcd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vcd_text3 || '自定义字段3'"
            v-model="item.vcd_text3" slot="vcd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vcd_text4 || '自定义字段4'"
            v-model="item.vcd_text4" slot="vcd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vcd_text5 || '自定义字段5'"
            v-model="item.vcd_text5" slot="vcd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="billName == '冲应付款' || billName == '冲预付款'"
      >
        <div class="weui-panel__hd">冲账科目</div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items3"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.vcc_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="vcc_catename">
              <label class="weui-form-preview__label">{{
                customLabel.vcc_catename || "冲账科目"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vcc_catename
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vcc_amount">
              <label class="weui-form-preview__label">{{
                customLabel.vcc_amount || "本次冲账金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.vcc_amount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vcc_remark">
              <label class="weui-form-preview__label">{{
                customLabel.vcc_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vcc_remark
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.vc_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.vc_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">核销金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.vc_amount1
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">未核销金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.vc_amount2
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/money/verification",
      form: {
        main: {},
        items1: [],
        items2: [],
      },
      caller: "Verification",
      xtype: "money-verification-rec-formpanel",
      // billTypes: {
      //   receipts_offset_receivable: "预收冲应收",
      //   receivable_offset_payable: "应收冲应付",
      //   receivable_to_receivable: "应收转应收"
      // }
    };
  },
  computed: {
    billName() {
      var type = this.form.main.vc_kind;
      return type;
    },
  },
};
</script>